import { User } from '../../shared/types'
import { useUserGet } from '../api/users'

export function getUserLabel(user?: User) {
	if (!user) return 'smazaný uživatel'
	const { given_name = '', family_name = '', email } = user
	if (!given_name && !family_name) return email
	const displayName = `${given_name} ${family_name}`.trim()
	return displayName
}

export function UserFormatter({ id }: { id?: string }) {
	const { data: user, isSuccess } = useUserGet(id)

	if (!id) return <span>-</span>
	if (!isSuccess) return <span></span>
	if (!user) return <em>smazaný uživatel</em>

	return <>{getUserLabel(user)}</>
}
